export const buttonTypes = {
  ICON: "icon",
  RAW: "raw",
  SIMPLE: "simple",
};
